export const LOGIN = (state) => {
    state.logged = true;
}

export const ROLE = (state, value) => {
    console.log(value)
    state.role = value;
}

export const LOGOUT = (state) => {
    state.logged = false;
}

export const GETTEDDATA = (state, obj) => {



    if (obj.id == 0) {
        state.getted_data_0 = Object.assign({}, state.getted_data_0, obj.data)
    } else if (obj.id == 1) {
        state.getted_data_1 = Object.assign({}, state.getted_data_1, obj.data)
    } else if (obj.id == 2) {
        state.getted_data_2 = Object.assign({}, state.getted_data_2, obj.data)
    } else if (obj.id == 3) {
        state.getted_data_3 = Object.assign({}, state.getted_data_3, obj.data)
    } else if (obj.id == 4) {
        state.getted_data_4 = Object.assign({}, state.getted_data_4, obj.data)
    } else if (obj.id == 5) {
        state.getted_data_5 = Object.assign({}, state.getted_data_5, obj.data)
    } else if (obj.id == 6) {
        state.getted_data_6 = Object.assign({}, state.getted_data_6, obj.data)
    } else if (obj.id == 7) {
        state.getted_data_7 = Object.assign({}, state.getted_data_7, obj.data)
    } else if (obj.id == 8) {
        state.getted_data_8 = Object.assign({}, state.getted_data_8, obj.data)

    }
}